export default __webpack_public_path__ + "static/media/Chariot-Logo-PassengerApp.6895005b.png";